import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import { Container, Stack, Flex } from '@chakra-ui/react'
import { Spinner } from '@pnld/components-web'

import { ROUTES } from '@/config/routes'
import { useAuth } from '@/contexts/AuthContext'
import { useUser } from '@/contexts/UserContext'
import { useBreadcrumbProps, useSidebarItems } from '@/data/template'

import Breadcrumbs from './parts/Breadcrumbs'
import Sidebar from './parts/Sidebar'

const TemplatePage: React.FC = () => {
  const breadcrumbProps = useBreadcrumbProps()
  const sidebarItems = useSidebarItems()
  const { isLoading: isUserLoading } = useUser()
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth()

  const isLoading = isAuthLoading || isUserLoading

  if (isLoading) {
    return (
      <Flex align="center" justify="center" w="100" h="100vh">
        <Spinner size="xl" color="brand.highlight.dark_2" />
      </Flex>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} />
  }

  return (
    <Sidebar {...sidebarItems}>
      <Container width="full" maxWidth="container.xl" padding={0}>
        <Stack spacing={4}>
          <Breadcrumbs {...breadcrumbProps} />
          <Outlet />
        </Stack>
      </Container>
    </Sidebar>
  )
}

export default TemplatePage
